import { CustomBox, TargetsWarning } from "@/common/StyledComponents"
import { formattedCurrency, uuidv4 } from "@/utils"
import { Button, CircularProgress, Grid, Modal, Tooltip, useTheme } from "@mui/material"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { selectSelectedBills, unCheckAllBills } from "./accountingBillsSlice"
import { CheckedTotal } from "./AccountingBills"
import { ACCOUNTING_BILL_STATUS_SYNCED } from "@/actuals/constants"
import { request } from "@/Api"
import { setError } from "@/nav/navSlice"

export default function AccountingBillsCreateBatchPopup({ refresh }) {
    const dispatch = useDispatch()
    const theme = useTheme()
    const [ open, setOpen ] = useState(false)
    const [ waiting, setWaiting ] = useState(false)
    const selectedBills = Object.values(useSelector(selectSelectedBills))
    const sameLegalEntity = selectedBills.every((bill) => {
        return bill.legal_entity_id == selectedBills[0].legal_entity_id
    })
    const legalEntityId = selectedBills.length > 0 ? selectedBills[0].legal_entity_id : null
    const firstBillStatus = selectedBills.length > 0 ? selectedBills[0].status : null
    const canBatch = selectedBills.length > 0 && sameLegalEntity && firstBillStatus == ACCOUNTING_BILL_STATUS_SYNCED
    const handleStartBatching = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }
    const handlePopupConfirm = () => {
        setWaiting(true)
        const selectedBillIds = selectedBills.map((bill) => bill.id)
        request.post("accounting-bills/batch", {
            accounting_bill_ids: selectedBillIds,
            accounting_bill_batch: {
                legal_entity_id: legalEntityId,
                name: `Batch of ${uuidv4()}`,
            }
        })
        .then((response) => {
            if (response.status == 200) {
                dispatch(setError({ message: "Bills batched successfully", severity: "success" }))
                refresh()
                dispatch(unCheckAllBills())
            }
        })
        .catch((err) => {
            dispatch(setError({ message: JSON.stringify(err.response ? err.response.data.detail : err), severity: "error" }))
        })
        .finally(() => {
            setWaiting(false)
            handleClose()
        })
    }
    return (
        <>
            {selectedBills.length > 0 && 
            <Tooltip title={!canBatch && "Bills must be from the same legal entity to batch, and all bills must be synced"}>
                <span>
                    <Button disabled={!canBatch} variant="contained" color="primary" onClick={handleStartBatching}>
                        Batch
                    </Button>
                </span>
            </Tooltip>}
            <Modal open={open} onClose={handleClose}>
                <CustomBox sx={{
                    paddingLeft: 4,
                    paddingRight: 4,
                    background: theme.palette.background.default,
                    overflow: "scroll",
                    width: "80%",
                }}>
                    <TargetsWarning>
                        <p>You are about to create a batch for the following bills: </p>
                        {selectedBills.map((bill, index) =>
                            <Grid container key={index} justifyContent={"space-between"}>
                                <Grid item>
                                    <p>
                                        invoice number {bill.accounting_bill_number || "n/a"} from vendor {bill.vendor_name}.
                                    </p>
                                </Grid>
                                <Grid item>
                                    <p key={index}>
                                        {formattedCurrency(bill.total, bill.currency)}
                                    </p>
                                </Grid>
                            </Grid>
                        )}
                        <div style={{textAlign: "right", paddingTop: 19}}>
                            <CheckedTotal />
                        </div>
                    </TargetsWarning>
                    <div style={{textAlign: "right"}}>
                        { waiting ? <CircularProgress /> : <div style={{textAlign: "right"}}><Button variant="contained" onClick={handlePopupConfirm}>Batch</Button></div>}
                    </div>
                </CustomBox>
            </Modal>
        </>
    )
}